import { Severity } from "@gripp/shared-logic";
import { View } from "react-native";
import { Icon } from 'react-native-paper';
import { Colors } from "../../themes";
import { SeverityIcons } from "../issue";

type IssuesSeverityIconProps = {
  severity: Severity;
  size?: number;
  color?: string;
}

export const IssuesSeverityIcon = (props: IssuesSeverityIconProps) => {
  const iconContainer = {
    backgroundColor: Colors[props.severity],
    width: 31,
    height: 20,
    borderRadius: 4,
    marginRight: 4,
    flexDirection: 'row' as const,
    justifyContent: 'center' as const,
    alignItems: 'center' as const,
    alignSelf: 'flex-start' as const,
  };

  const size = props.size || 16;
  const color = props.color || Colors.white;

  return (
    <View style={iconContainer}>
      <Icon
        size={size}
        color={color}
        source={SeverityIcons[props.severity]}
      />
    </View>
  );
};